/* Matmuis hero-slider – gedrag (10 okt 2026) */
(function () {
  function init(root) {
    if (!root || root.dataset.ready) return;
    var track = root.querySelector('[data-hs-track]');
    if (!track) return;
    root.dataset.ready = '1';
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-hs-slide]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-hs-tab]'));
    var n = slides.length;
    if (n < 2) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dur = Math.max(3, parseFloat(root.dataset.speed) || 6) * 1000;
    var stopped = !(root.dataset.autoplay === 'true' && !reduce);
    var idx = 0, elapsed = 0, last = 0, hover = false, focus = false, visible = true, scrollTimer = null, resizeTimer = null;

    function padL() { return parseFloat(getComputedStyle(track).paddingLeft) || 0; }
    function setActive(i) {
      idx = i; elapsed = 0;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      tabs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        if (k === i) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
        t.style.setProperty('--p', k === i && stopped ? 1 : 0);
      });
    }
    function go(i, instant) {
      i = (i + n) % n;
      track.scrollTo({ left: slides[i].offsetLeft - padL(), behavior: (instant || reduce) ? 'auto' : 'smooth' });
      setActive(i);
    }
    function stop() {
      if (stopped) return;
      stopped = true;
      if (tabs[idx]) tabs[idx].style.setProperty('--p', 1);
    }

    /* Actieve slide bepalen na swipen/scrollen */
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var x = track.scrollLeft + padL(), best = 0, bd = Infinity;
        slides.forEach(function (s, k) { var d = Math.abs(s.offsetLeft - x); if (d < bd) { bd = d; best = k; } });
        if (best !== idx) setActive(best);
      }, 90);
    }, { passive: true });

    /* Automatisch afspelen met voortgangsbalk */
    function frame(t) {
      var dt = last ? Math.min(t - last, 100) : 0;
      last = t;
      if (!stopped && !hover && !focus && visible && !document.hidden) {
        elapsed += dt;
        if (elapsed >= dur) { go(idx + 1); }
        else if (tabs[idx]) { tabs[idx].style.setProperty('--p', (elapsed / dur).toFixed(4)); }
      }
      if (!stopped) requestAnimationFrame(frame);
    }

    /* Pauzeren bij hover/focus, stoppen zodra iemand zelf bedient */
    root.addEventListener('mouseenter', function () { hover = true; });
    root.addEventListener('mouseleave', function () { hover = false; });
    root.addEventListener('focusin', function () { focus = true; });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) focus = false; });
    track.addEventListener('pointerdown', stop, { passive: true });
    track.addEventListener('touchstart', stop, { passive: true });
    track.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) stop(); }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault(); stop(); go(idx + (e.key === 'ArrowRight' ? 1 : -1));
      }
    });
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { stop(); go(k); }); });
    var prev = root.querySelector('[data-hs-prev]'), next = root.querySelector('[data-hs-next]');
    if (prev) prev.addEventListener('click', function () { stop(); go(idx - 1); });
    if (next) next.addEventListener('click', function () { stop(); go(idx + 1); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }, { threshold: 0.3 }).observe(root);
    }
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { go(idx, true); }, 150);
    });

    /* Thema-editor: geselecteerde slide tonen */
    document.addEventListener('shopify:block:select', function (e) {
      var k = slides.indexOf(e.target);
      if (k > -1) { stop(); go(k, true); }
    });

    setActive(0);
    if (!stopped) requestAnimationFrame(frame);
  }

  function initAll() { document.querySelectorAll('[data-hs]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-hs]')); });
})();
